import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            精选推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            编辑精选的优质影视内容，每一部都值得看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.slice(0, 6).map((card) => (
            <div
              key={card.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[5/3] overflow-hidden bg-background-200">
                <img
                  src={card.cover}
                  alt={card.title}
                  title={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="400"
                  height="240"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-[11px] bg-accent-500/90 text-background-50 rounded-md font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 line-clamp-2 leading-snug">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-1">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {cardsData.length > 6 && (
          <div className="mt-6">
            <div className="bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6 cursor-pointer hover:border-primary-500/30 transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="w-[120px] h-[80px] flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={cardsData[6].cover}
                    alt={cardsData[6].title}
                    className="w-full h-full object-cover"
                    width="400"
                    height="240"
                  />
                </div>
                <div>
                  <span className="text-[11px] bg-secondary-100/80 text-secondary-700 px-2 py-0.5 rounded-md font-medium">
                    {cardsData[6].tag}
                  </span>
                  <h3 className="mt-2 text-sm font-medium text-foreground-800">{cardsData[6].title}</h3>
                  <p className="mt-1 text-xs text-foreground-500">{cardsData[6].desc}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}